import { GoogleOAuthProvider } from "@react-oauth/google";
import map from "lodash/map";
import React, { Suspense } from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { PersistGate } from "redux-persist/integration/react";
import { googleClientId } from "../../conf";
import ChannelsContext from "../../contexts/ChannelsContext";
import PrefencesContext from "../../contexts/PreferencesContext";
import routes from "../../routes";
import store, { persistedStore } from "../../store";
import Body from "../Body";
import Control from "../Control";
import Loading from "../Loading";
import Notification from "../Notification";
import RouteWithSubRoutes from "../RouteWithSubRoutes/RouteWithSubRoutes";
import SizeContext from "../SizeContext";

const Root = () => {
  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistedStore}>
          <BrowserRouter basename="/old">
            <Control>
              <PrefencesContext>
                <SizeContext>
                  <ChannelsContext>
                    <Body>
                      <Suspense fallback={<Loading />}>
                        <Switch>
                          {map(routes, (route, index) => (
                            <RouteWithSubRoutes key={index} {...route} />
                          ))}
                        </Switch>
                        <Notification />
                      </Suspense>
                      <ToastContainer
                        closeButton={false}
                        hideProgressBar={true}
                      />
                    </Body>
                  </ChannelsContext>
                </SizeContext>
              </PrefencesContext>
            </Control>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </GoogleOAuthProvider>
  );
};
export default Root;
